import Vue from 'vue'

// input输入去空格
Vue.directive('inputTrim', {
  inserted: function (el) {
    const $input = el.querySelector('input');
    if ($input) {
      $input.onkeyup = function () {
        this.value = this.value.replace(/\s+/g,'');
      }
    }
  }
});


// WEBPACK FOOTER //
// ./src/utils/directives.js